module.exports = __webpack_public_path__ + "img/einstein.4124efe3.jpg";